import React from 'react';
import { Typography } from '@mui/material';
import LegalPage from '../../components/LegalPage/LegalPage';

const Privacy = () => (
    <LegalPage product="CVPro" title="Privacy Policy">
        <p><strong>Effective Date:</strong> March 22, 2026</p>
        <p>
            CVPro ("we", "our", or "us") collects and processes information to help users create and manage digital resumes.
        </p>

        <Typography variant="h6">1. Information We Collect</Typography>
        <ul>
            <li>Personal Information (name, email)</li>
            <li>Resume Data (education, experience, skills)</li>
            <li>Uploaded Content (if applicable)</li>
            <li>Device &amp; usage data</li>
        </ul>

        <Typography variant="h6">2. How We Use Your Information</Typography>
        <ul>
            <li>Generate resumes and CVs</li>
            <li>Allow export (PDF/download)</li>
            <li>Improve user experience</li>
        </ul>

        <Typography variant="h6">3. Data Storage</Typography>
        <p>
            Your data is securely stored using cloud-based services.
        </p>

        <Typography variant="h6">4. Third-Party Services</Typography>
        <p>We may use:</p>
        <ul>
            <li>Cloud storage providers</li>
            <li>Analytics tools</li>
        </ul>
        <p>We do not sell your data.</p>

        <Typography variant="h6">5. Data Ownership</Typography>
        <p>
            You own all resume data you create.
        </p>

        <Typography variant="h6">6. Data Deletion</Typography>
        <p>
            You may request deletion at any time via: evolvedevlabs@gmail.com
        </p>

        <Typography variant="h6">7. Security</Typography>
        <p>
            We take reasonable steps to protect your data.
        </p>

        <Typography variant="h6">8. Children's Privacy</Typography>
        <p>
            Not intended for users under 13.
        </p>

        <Typography variant="h6">9. Updates</Typography>
        <p>
            We may update this policy.
        </p>

        <Typography variant="h6">10. Contact</Typography>
        <p>Email: evolvedevlabs@gmail.com</p>
    </LegalPage>
);

export default Privacy;
